<template>
  <base-container ref="container" style="height: 100%">
    <ArtisanGrid
      ref="resouce"
      metaKey="JyResourceInfo"
      :metaInited="metaInited"
      isTree
      defaultExpandAll
      :query="{ hosId: hosId }"
      :showDialogBefore="showDialogBefore"
    >
      <template #formFooter="{ row }">
        <artisan-group title="窗口检验项目">
          <el-row style="margin-bottom: 10px">
            <el-col :span="12">
              <el-select size="mini" v-model="projectType" style="width: 100%">
                <el-option
                  :value="type.value"
                  :label="type.label"
                  v-for="type in projectTypes"
                  :key="type.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-input
                size="mini"
                v-model="val"
                placeholder="搜索关键字"
              ></el-input>
            </el-col>
          </el-row>
          <el-checkbox-group v-model="row.projectIds">
            <el-checkbox
              style="width: 50%; margin-right: 0"
              v-show="
                project.type == projectType &&
                (project.deptId == row.deptId || !row.deptId) &&
                (project.name.indexOf(val) >= 0 || !val)
              "
              v-for="project in projects"
              :key="project.id"
              :label="project.id"
            >
              {{ project.name }}
            </el-checkbox>
          </el-checkbox-group>
        </artisan-group>
      </template>
    </ArtisanGrid>

  </base-container>
</template>

<script>
import { listByHos } from "@/api/jy/project";
import { loadEnum } from "@/api/sys/dicType";
export default {
  props: {
    hosId: String,
    hosDepts: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      isShow: false,
      isLoading: false,
      projectType: "",
      projectTypes: [],
      projects: [],
      val: "",
      data: "",
      belongId: "",
      belongType: "",
    };
  },
  computed: {
    hosDeptItems() {
      return this.hosDepts.map((c) => {
        return { label: c.name, value: c.id };
      });
    },
  },
  created() {
    listByHos(this.hosId).then((res) => {
      this.projects = res.data.data;
    });
    loadEnum("JyProjectType").then((res) => {
      this.projectTypes = res.data.data;
      this.projectType = this.projectTypes[0].value;
    });
  },
  methods: {
    metaInited(option) {
      let col = option.columns.find((c) => c.code == "deptId");
      if (col) {
        col.dicData = this.hosDeptItems;
      }
    },
 
    showDialogBefore(dialog, row, btn) {
      if (!row.projectIds) {
        row.projectIds = [];
      }
      if (btn.code == "roomAddDevice") {
        this.$refs.resouce.getColumn("type").isAdd = false;
        dialog.dialogClose = () => {
          this.$refs.resouce.getColumn("type").isAdd = true;
        };
      }
      dialog.isShow = true;
    },
    roomAddDevice(row, btn) {
      btn.title = "添加设备--" + row.name;
      let data = {
        type: "device",
        parentId: row.id,
        deptId: row.deptId,
        projectIds: [],
      };
      this.$refs.resouce.toAdd(btn, data);
    },
  },
};
</script>

<style scoped>
</style>